export class SiteReport {
    SiteCode: string;
    SiteName: string;
    //SiteNumber: number;
    //StudyId: number;
    //AppendixIds: number[];
    PlatformName: string;
    TrialName: string;
    SiteRandomizedCount: number;
    TrialRandomizedCount: number;
    DaysSinceLastRandomizationSite: number;
    DaysSinceLastRandomizationTrial: number;
    MonthsSinceActivation: string;
    EnrolledLast30Days: number;
    DaysFromInitatedToExecuted: number;
    DaysFromRegSentToRegComplete: number;
    DaysFromActivationToRandomization: number;
    TotalPartialStudyInverventionCompleters: number;
    TotalDiscontinuedIntervention: number;
    TotalDiscontinuedStudy: number;
    TotalHispanic: number;
    TotalNonWhite: number;
    TotalHispanicOrNonWhite: number;
    TotalFemale: number;
    TotalVisitsNotDone: number;
    TotalVisitsCompletedOutOfWindow: number;
    TotalVisits: number;
    TotalNotEvaluable: number;
    AppendixDropped: number;

    PercentPartialStudyInverventionCompleters: string;
    PercentDiscontinuedIntervention: string;
    PercentDiscontinuedStudy: string;
    PercentHispanic: string;
    PercentNonWhite: string;
    PercentHispanicOrNonWhite: string;
    PercentFemale: string;
    PercentVisitsNotDone: string;
    PercentVisitsCompletedOutOfWindow: string;
    PercentNotEvaluable: string;
    EnrollmentPerMonth: number;
    NeedsPercentCalculation: boolean;

    //Other Fields
    //StudyName: string;

    Initialize(): void {
        if (this.NeedsPercentCalculation) {
            this.PercentPartialStudyInverventionCompleters = ((this.TotalPartialStudyInverventionCompleters / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentDiscontinuedIntervention = ((this.TotalDiscontinuedIntervention / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentDiscontinuedStudy = ((this.TotalDiscontinuedStudy / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentHispanic = ((this.TotalHispanic / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentNonWhite = ((this.TotalNonWhite / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentHispanicOrNonWhite = ((this.TotalHispanicOrNonWhite / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentFemale = ((this.TotalFemale / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
            this.PercentVisitsNotDone = ((this.TotalVisitsNotDone / this.TotalVisits) * 100).toFixed(2) + "%";
            this.PercentVisitsCompletedOutOfWindow = ((this.TotalVisitsCompletedOutOfWindow / this.TotalVisits) * 100).toFixed(2) + "%";
            this.PercentNotEvaluable = ((this.TotalNotEvaluable / this.TrialRandomizedCount) * 100).toFixed(2) + "%";
        }
        //let studyMap = new Map<number, string>();
        //studyMap.set(2, "VITAL");
        //studyMap.set(3, "NEURO");
        //studyMap.set(4, "SLEEP");
        //studyMap.set(5, "AUTONOMIC");
        //studyMap.set(6, "ENERGIZE");
        //this.StudyName = studyMap.get(this.StudyId);

        //some are infinity and that shouldn't happen
        if (this.DaysFromInitatedToExecuted == -1) {
            this.DaysFromInitatedToExecuted = 0;
        }
        if (this.DaysFromRegSentToRegComplete == -1) {
            this.DaysFromRegSentToRegComplete = 0;
        }
        if (this.DaysFromActivationToRandomization == -1) {
            this.DaysFromActivationToRandomization = 0;
        }
        if (!this.DaysSinceLastRandomizationTrial) {
            this.DaysSinceLastRandomizationTrial = -1;
        }
        if (this.DaysSinceLastRandomizationTrial != -1) {
            this.DaysSinceLastRandomizationTrial = parseFloat(this.DaysSinceLastRandomizationTrial.toFixed(2));
        }
        if (this.MonthsSinceActivation == "-1" || this.MonthsSinceActivation == null || this.MonthsSinceActivation == "") {
            this.MonthsSinceActivation = "0";
        }
        if (!this.TrialRandomizedCount) {
            this.TrialRandomizedCount = 0;
        }
        if (!this.TrialName) {
            this.TrialName = "";
        }
        if (!this.EnrollmentPerMonth) {
            this.EnrollmentPerMonth = 0;
        }
        if (!this.PercentPartialStudyInverventionCompleters || this.PercentPartialStudyInverventionCompleters == NaN.toString() + "%") {
            this.PercentPartialStudyInverventionCompleters = "0%";
        }
        if (!this.PercentDiscontinuedStudy || this.PercentDiscontinuedStudy == NaN.toString() + "%") {
            this.PercentDiscontinuedStudy = "0%";
        }
        if (!this.PercentHispanic || this.PercentHispanic == NaN.toString() + "%") {
            this.PercentHispanic = "0%";
        }
        if (!this.PercentNonWhite || this.PercentNonWhite == NaN.toString() + "%") {
            this.PercentNonWhite = "0%";
        }
        if (!this.PercentHispanicOrNonWhite || this.PercentHispanicOrNonWhite == NaN.toString() + "%") {
            this.PercentHispanicOrNonWhite = "0%";
        }
        if (!this.PercentFemale || this.PercentFemale == NaN.toString() + "%") {
            this.PercentFemale = "0%";
        }
        if (!this.PercentNotEvaluable || this.PercentNotEvaluable == NaN.toString() + "%") {
            this.PercentNotEvaluable = "0%";
        }
        if (!this.PercentVisitsNotDone || this.PercentVisitsNotDone == NaN.toString()+"%") {
            this.PercentVisitsNotDone = "0%";
        }
        if (!this.PercentVisitsCompletedOutOfWindow || this.PercentVisitsCompletedOutOfWindow == NaN.toString() + "%") {
            this.PercentVisitsCompletedOutOfWindow = "0%";
        }
        if (!this.PercentDiscontinuedIntervention || this.PercentDiscontinuedIntervention == NaN.toString() + "%") {
            this.PercentDiscontinuedIntervention = "0%";
        }
        if (!this.DaysFromInitatedToExecuted) {
            this.DaysFromInitatedToExecuted = -1;
        }
        if (!this.DaysFromRegSentToRegComplete) {
            this.DaysFromRegSentToRegComplete = -1;
        }
        if (!this.DaysFromActivationToRandomization) {
            this.DaysFromActivationToRandomization = -1;
        }
        if (!this.EnrolledLast30Days) {
            this.EnrolledLast30Days = 0;
        }

        if (parseFloat(this.MonthsSinceActivation) < 0.1) {
            this.EnrollmentPerMonth = this.EnrolledLast30Days;
        }
        else {
            this.EnrollmentPerMonth = parseFloat((this.TrialRandomizedCount / parseFloat(this.MonthsSinceActivation)).toFixed(2));
        }
        //this.MonthsSinceActivation = parseFloat(this.MonthsSinceActivation).toFixed(2);

    }
}